import { render, staticRenderFns } from "./canvasjs.vue?vue&type=template&id=7022ee0f&"
import script from "./canvasjs.vue?vue&type=script&lang=js&"
export * from "./canvasjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports